import React, { useRef } from "react";
import { Form } from "antd";
import { getRequiredRule } from "@/utils/formValidatorRules";
import { observer } from "mobx-react-lite";
import { MultiShopSelectPlatformType, MultiShopSelectPlatformTypeName } from "@/components/MultiShopSelect/types";
import MultiPlatformUseChildWaybillNoModeFormItem from "./MultiPlatformUseChildWaybillNoModeFormItem";
import WaybillPrinter from "@/services/print/waybill/WaybillPrinter";
import PrinterSelect from "@/components/PrinterSelect";
import TemplateSelectExtra from "./TemplateSelectExtra";
import WaybillTemplateSelect from "@/components/WaybillTemplateSelect2";
import ShopType from "@/enum/ShopType";

interface WaybillTemplateFormItemProps {
    platform: MultiShopSelectPlatformType;

    defaultTemplateId?: number;

    showPrinterTip?: boolean;

    showExtra?: boolean;

    required?: boolean;
}

const WaybillTemplateFormItem: React.FC<WaybillTemplateFormItemProps> = function (props) {
    const { platform, defaultTemplateId, showPrinterTip = true, showExtra = true, required } = props;

    const showPrinterTipRef = useRef(showPrinterTip);

    return (
        <Form.Item
            noStyle
            shouldUpdate={(prev, next) =>
                prev[platform]?.template !== next[platform]?.template ||
                prev.isGenerateWaybillNoOnly !== next.isGenerateWaybillNoOnly
            }
        >
            {(form) => {
                const values = form.getFieldsValue();

                const template = values[platform]?.template;
                const isGenerateWaybillNoOnly = values.isGenerateWaybillNoOnly;
                const printerSelectRules = !isGenerateWaybillNoOnly ? [getRequiredRule("打印机不能为空")] : null;

                let filterableShopType;

                if (platform === MultiShopSelectPlatformType.jd) {
                    filterableShopType = ShopType.JD;
                } else if (platform === MultiShopSelectPlatformType.channelShop) {
                    filterableShopType = ShopType.CHANNEL_SHOP;
                } else if (platform === MultiShopSelectPlatformType.ali) {
                    filterableShopType = ShopType.ALIBABA;
                }

                return (
                    <div className="multi-platform-print-waybill-form-item-container">
                        <div style={{ display: "flex", width: "100%" }}>
                            <Form.Item
                                style={{
                                    flex: 1,
                                }}
                                label={`${MultiShopSelectPlatformTypeName[platform]}订单模板`}
                                // extra={buildTemplateSelectExtra(template)}
                                name={[platform, "template"]}
                                rules={[getRequiredRule("快递单模板不能为空")]}
                                required={required}
                                labelCol={{
                                    span: 8,
                                }}
                                wrapperCol={{ span: 16 }}
                                extra={
                                    showExtra ? <TemplateSelectExtra platform={platform} template={template} /> : null
                                }
                            >
                                <WaybillTemplateSelect
                                    filterableShopType={filterableShopType}
                                    popupMatchSelectWidth={false}
                                    hideRefresh
                                    style={{ width: 280 }}
                                    orderSourceCategory={platform}
                                    defaultTemplateId={defaultTemplateId}
                                    onChange={(template) => {
                                        if (showPrinterTipRef.current) {
                                            if (template && !WaybillPrinter.isReady(template)) {
                                                WaybillPrinter.openDownloadPluginDialog(template);
                                                showPrinterTipRef.current = false;
                                            }
                                        }
                                    }}
                                />
                            </Form.Item>

                            <Form.Item
                                style={{
                                    flex: 1,
                                }}
                                label="打印机"
                                name={[platform, "printerName"]}
                                rules={printerSelectRules}
                                required={required}
                                labelCol={{
                                    span: 7,
                                }}
                                wrapperCol={{ span: 16 }}
                            >
                                <PrinterSelect
                                    style={{ width: 240 }}
                                    disabled={isGenerateWaybillNoOnly}
                                    template={template}
                                />
                            </Form.Item>
                        </div>

                        <MultiPlatformUseChildWaybillNoModeFormItem platform={platform} />
                    </div>
                );
            }}
        </Form.Item>
    );
};

export default observer(WaybillTemplateFormItem);
